import parser from './parser';

const name = 'select';


export default {parser, name};
